import React, { Component } from "react";
import { Link } from "react-router-dom";
import api from "../../config/api";
import { connect } from "react-redux";
import {
  debitsSelectedComp,
  registerDebitAutomaticComp,
  openSnackComp,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography, Paper, Divider, Button } from "@material-ui/core";
import TableRegisterAutomaticDebitsSelecteds from "../../components/TableRegisterAutomaticDebitsSelecteds";
import CheckboxDebitAutomaticRegister from "../../components/CheckboxDebitAutomaticRegister";
import ButtonTypeName from "../../components/ButtonTypeName";
import Snackbar from "../../components/Snackbar";
import { checkDebitsExist } from "../../helper/checkDebitsExist";
import { handleCreateObj } from "../../helper/createObjDA";

const styles = (theme) => ({
  title: {
    position: "relative",
    marginTop: 30,
    textAlign: "center",
  },
  buttonBack: {
    position: "absolute",
    top: 5,
    left: 30,
  },
  container: {
    padding: "20px 35px",
  },
  linkGroup: {
    textDecoration: "none",
  },
  button: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
    background: "none",
    border: "none",
    boxShadow: "none",
  },
  menuGroup: {
    display: "flex",
    width: "100%",
    marginTop: "10px",
    marginBottom: "30px",
    padding: "20px 0px 0px 0px",
  },
  inputs: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "20px 0",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  inputsItem: {
    width: "initial",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center",
    },
  },
  paper: {
    width: "100%",
    padding: 15,
  },
  paperTitle: {
    fontSize: 16,
  },
  inputsBankGroup: {
    display: "flex",
    alignItems: "baseline",
    marginBottom: 30,
  },
  relacao: {
    padding: "25px 0 15px 0",
    fontSize: 16,
  },
});

export class DebitsAutomaticRegister extends Component {
  state = {
    msg: "",
  };

  componentDidMount() {
    checkDebitsExist(this.props);
    this.props.openSnackComp(false);
    handleCreateObj(this.props);
  }

  handleChangeQuotas = () => {
    const obj = {
      Cotas: this.props.registerDebitAutomaticValue.Cotas,
      CotasUnicas: this.props.registerDebitAutomaticValue.CotasUnicas,
    };

    api
      .post("Debitos/AlterarOpcaoCotas", obj)
      .then((changedQuotas) => {
        if (changedQuotas.data.ResultadoValidacao.Validado) {
          this.setState(
            {
              msg: "Cotas alteradas com sucesso!",
            },
            () => {
              this.props.openSnackComp(true);
            }
          );
        } else {
          changedQuotas.data.ResultadoValidacao.Erros.forEach((element) => {
            this.setState(
              {
                msg: element.Mensagem,
              },
              () => {
                this.props.openSnackComp(true);
              }
            );
          });
        }
      })
      .catch((error) => {
        this.setState(
          {
            msg: error.Mensagem,
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Snackbar message={this.state.msg} />
        <div className={classes.selectedDebits}>
          <Grid container className={classes.container}>
            <div className={classes.menuGroup} style={{ marginTop: "140px" }}>
              <Link to="/debito-automatico" className={classes.linkGroup}>
                <Button variant="contained" className={classes.button}>
                  <span>{"<"} VOLTAR</span>
                </Button>
              </Link>
            </div>
            <Paper className={classes.paper}>
              <Divider />

              <Typography
                variant="h6"
                color="textSecondary"
                className={classes.relacao}
              >
                RELAÇÃO
              </Typography>
              <TableRegisterAutomaticDebitsSelecteds
                rows={this.props.debitsSelectedValue}
                typeTable={2}
                props={this.props}
              />
            </Paper>

            <div>
              <CheckboxDebitAutomaticRegister />
            </div>

            <div className={classes.inputs}>
              <div
                className={classes.inputsItem}
                onClick={this.handleChangeQuotas}
              >
                <ButtonTypeName
                  typeButton={5}
                  quotasSize={this.props.debitsSelectedValue.length}
                />
              </div>
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  registerDebitAutomaticValue: store.cardDebitState.registerDebitAutomaticValue,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { debitsSelectedComp, registerDebitAutomaticComp, openSnackComp },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(DebitsAutomaticRegister)
);
